const block_icons     = {
    multi_button_child:    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 512 512"
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fill="#f32626"
      d="M376.5 120.5h-241C60.785 120.5 0 181.285 0 256s60.785 135.5 135.5 135.5h241c74.715 0 135.5-60.785 135.5-135.5s-60.785-135.5-135.5-135.5zm0 241C318.327 361.5 271 314.174 271 256c0-58.172 47.327-105.5 105.5-105.5S482 197.828 482 256c0 58.174-47.327 105.5-105.5 105.5z"
      data-original="#000000"
    ></path>
  </svg>
}

export default block_icons;